import { makeResponse } from '@/common/api/utils';
import api from '@/common/api';


export const fetchResearchSet = async (researchSetUUID) => (
  makeResponse(
    await api.get(
      `public/research-sets/${researchSetUUID}/`,
    ),
  )
);

export const fetchResearchSets = async () => (
  makeResponse(await api.get('public/research-sets/'))
);

export const fetchOrganisation = async (organisationSlug) => (
  makeResponse(
    await api.get(
      `public/organisations/${organisationSlug}/`,
    ),
  )
);

export const fetchOrganisations = async (type, hasPaidLicence, orderRandom) => (
  makeResponse(
    await api.get(
      'public/organisations/',
      { type, has_paid_license: hasPaidLicence, order_random: orderRandom },
    ),
  )
);

export const fetchOrganisationStatistics = async (organisationSlug) => (
  makeResponse(
    await api.get(
      `public/organisations/${organisationSlug}/stats/`,
    ),
  )
);

export const fetchRelatedOrganisations = async (organisationSlug) => (
  makeResponse(
    await api.get(
      `public/organisations/${organisationSlug}/related-organisations/`,
    ),
  )
);

export const fetchPartners = async () => (
  makeResponse(
    await api.get('public/partners/'),
  )
);
